import { typeof as _typeof } from '../_virtual/_rollupPluginBabelHelpers.js';

/* eslint-disable @typescript-eslint/no-explicit-any */

// forked from https://github.com/chakra-ui/chakra-ui/blob/main/packages/utils/src/assertion.ts

// Number assertions
function isNumber(value) {
  return typeof value === 'number' && !isNaN(value);
}
function isNotNumber(value) {
  return typeof value !== 'number' || Number.isNaN(value) || !Number.isFinite(value);
}
function isNumeric(value) {
  var regex = /^[^.]*$/;
  return value != null && regex.test("".concat(value)) ? !isNaN(parseFloat(value)) : value - parseFloat(value) + 1 >= 0;
}

// Array assertions
function isArray(value) {
  return Array.isArray(value);
}
function isEmptyArray(value) {
  return isArray(value) && value.length === 0;
}

// Function assertions
function isFunction(value) {
  return typeof value === 'function';
}

// Generic assertions
function isDefined(value) {
  return typeof value !== 'undefined' && value !== undefined;
}
function isUndefined(value) {
  return typeof value === 'undefined' || value === undefined;
}

// Object assertions
function isObject(value) {
  var type = _typeof(value);
  return value != null && (type === 'object' || type === 'function') && !isArray(value);
}
function isEmptyObject(value) {
  return isObject(value) && Object.keys(value).length === 0;
}
function isNotEmptyObject(value) {
  return value && !isEmptyObject(value);
}
function isNull(value) {
  return value == null;
}

// String assertions
function isString(value) {
  return Object.prototype.toString.call(value) === '[object String]';
}
function isCssVar(value) {
  return /^var\(--.+\)$/.test(value);
}

// Empty assertions
function isEmpty(value) {
  if (isArray(value)) return isEmptyArray(value);
  if (isObject(value)) return isEmptyObject(value);
  if (value == null || value === '') return true;
  return false;
}
var __DEV__ = process.env.NODE_ENV !== 'production';
var __TEST__ = process.env.NODE_ENV === 'test';
function isRefObject(val) {
  return 'current' in val;
}
function isInputEvent(value) {
  return value && isObject(value) && isObject(value.target);
}

export { __DEV__, __TEST__, isArray, isCssVar, isDefined, isEmpty, isEmptyArray, isEmptyObject, isFunction, isInputEvent, isNotEmptyObject, isNotNumber, isNull, isNumber, isNumeric, isObject, isRefObject, isString, isUndefined };
//# sourceMappingURL=assertion.esm.js.map
